/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-02-01T17:22:46-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-07T13:24:23-07:00
*/

import React, { Component } from 'react';
import { Link } from 'react-router'
import TripDetailsHeader from './TripDetailsHeader';
import FavoritedList from './TripUsersList';
import glamorous, { Div } from 'glamorous'
import { css } from 'glamor'
import BlankSlate from '../../blocks/BlankSlate';
import Button from '../../blocks/Button';
import Container from '../../blocks/Container';
import UserBlock from './UserLockup';
import Text from '../../common/Text';
import tripInfo from './TripInfo';
import { tsDate, createGoogleMap } from "../../../common";
import {dimensions, box, spacing, type, textColor, borders, leading } from '../../../style';
import MediaQuery from 'react-responsive';

import Modal from '../../common/Modal';
import { MenuList, MenuListItem } from '../../blocks/MenuList';

const UserLockup = UserBlock()
const TripInfo = tripInfo()

// const Large = ({ children }) => <Responsive minWidth={772} children={children} />

const PageContainer = glamorous.div(
  {
    [dimensions.SCREEN_MIN_MD]: {
      display: 'flex',
      marginTop: 22,
      marginLeft: 22,
      marginRight: 22,
      backgroundColor: '#fff',
      border: '1px solid #DCDCDC'
    }
  }
)

const Column = glamorous.div(
  {
    flex: '0 0 50%',
  }
)

const MainColumn = glamorous(Column)({

})

const ActionContainer = glamorous.div(
  {
    padding: '8px 0',
    [dimensions.SCREEN_MIN_LG]: {
      marginLeft: '25%'
    }
  }
)

const postBtnStyle = css({
  display: 'block',
  padding: 6,
  textAlign: 'center',
  marginTop: 12
})


class TripDetails extends Component {


  constructor(props) {
    super(props);
    this.cancel = this.cancel.bind(this);
    this.renderButton = this.renderButton.bind(this);

    this.state = { modalOpen: false };

  }

  cancel(e) {
    e.preventDefault();
    //console.log(e.target.attributes.getNamedItem('data-reason'));
    let reason = e.target.attributes.getNamedItem('data-reason').value;
    let trip = this.props.trip.data;

    // close modal manually.
    this.setState({modalOpen: false}, () => { } );
    // cancel trip from API and store.
    ////console.log("TRIPKEY WE GOT: ", trip.tripKey);
    this.props.cancelTrip(trip.id,null,reason);
  }

  renderButton(trip, isMe) {
    if(isMe) return;
    // only render button if this is not my trip.
    if(trip.is_liked === null) {
      // can ask to join
      return (<Button fit variant="primary" onClick={() => {this.props.joinTrip(trip.id) }}>Ask to join</Button>);
    } else {
      // already asked to join
      return (<Button fit variant="simple">Asked!</Button>);
    }
  }

  render() {
    const {
      trip,
      likes,
      toggle,
      profile
    } = this.props

    if(trip.data) {
      const otherProfile = trip.data.profile.data;
      const otherAccount = otherProfile.account.data;
      const isMe = Boolean(Number(profile.id) === Number(trip.data.account_id));
      let staticMapImage;
      try {
        staticMapImage = createGoogleMap(trip.data.latitude, trip.data.longitude, {horizontal: 480, vertical: 580});
      } catch(e) {
        console.error(e);
      }
      const backdropPhoto = trip.data.photo && trip.data.photo.data[0] && trip.data.photo.data[0] ? trip.data.photo.data[0].path : staticMapImage;
      const hasPhoto = Boolean(trip.data.photo && trip.data.photo.data && trip.data.photo.data[0]);
  
      return (
        <Container padding='none'>
          <PageContainer>
            <Column css={{flexGrow: 1}}>
              <TripDetailsHeader
                username={otherAccount.username}
                city={trip.data.city}
                country={trip.data.country}
                region={trip.data.region}
                age={trip.data.profile.data.age}
                avatar={otherProfile.avatar.data.urls.profile}
                isMe={isMe}
                backdropPhoto={backdropPhoto}
                hasPhoto={hasPhoto}
              />
            </Column>
            <MainColumn>
              <Div padding={22}>
                { !isMe ?
                  <MediaQuery minWidth={783}>
                    <Div
                      marginBottom={22}
                      paddingBottom={22}
                      borderBottom="1px dotted #44BABB"
                    >
                      <UserLockup
                        username={otherAccount.username}
                        city={trip.data.city}
                        country={trip.data.country}
                        region={trip.data.region}
                        age={trip.data.profile.data.age}
                        avatar={otherProfile.avatar.data.urls.profile}
                      />
                    </Div>
                  </MediaQuery> :
                  null
                }
                <TripInfo trip={trip.data} />
                { isMe ?
                  <div
                    style={{
                      borderTop: '1px dotted #44BABB',
                      paddingTop: 24
                    }}
                  >
                    <Div
                      fontSize={18}
                      marginBottom={12}
                    >Members who asked to join this trip</Div>
                    <FavoritedList
                      rowType='simple'
                      favorites={likes}
                      toggle={toggle}
                      noResultsTitle='No one has asked to join this trip'
                      moreExists={this.props.moreExists}
                      tripId={trip.data.id}
                      loadMore={this.props.loadMore}
                    />
                  </div> :
                  <ActionContainer>
                    { this.renderButton(trip.data, isMe) }
                    <Link
                      className={`${postBtnStyle}`}
                      to={`/trip/create?city=${trip.data.city}&country=${trip.data.country}&region=${trip.data.region}`}>
                      <span
                        style={{
                          verticalAlign: 'middle',
                          marginRight: 8
                        }}
                      >
                      <svg width="16px" height="16px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <polygon id="Shape" fill="#000000" fillRule="nonzero" points="25 0 25 25 0 25 0 29 25 29 25 54 29 54 29 29 54 29 54 25 29 25 29 0"></polygon>
                        </g>
                      </svg>
                      </span>
                        Post A Similar Trip </Link>
                  </ActionContainer>
                }
              </Div>
              { isMe
                ? <div style={{textAlign: 'right', padding: '8px 22px 22px'}}>
                    <Modal buttonText={`Cancel This Trip`} openStatus={this.state.modalOpen}>
                      Are you sure you want to cancel this trip?
                      <MenuList>
                        <MenuListItem>
                          <Button fit onClick={this.cancel} data-reason="found_someone">I found Someone</Button>
                        </MenuListItem>
                        <MenuListItem>
                          <Button fit onClick={this.cancel} data-reason='wanted_new'>I meant to create a different trip</Button>
                        </MenuListItem>
                        <MenuListItem>
                          <Button fit onClick={this.cancel} data-reason='not_interested'>I'm no longer interested in going</Button>
                        </MenuListItem>
                        <MenuListItem>
                          <Button fit onClick={this.cancel}></Button>
                        </MenuListItem>
                      </MenuList>
                    </Modal>
                  </div>
                : null
                }
            </MainColumn>
          </PageContainer>
        </Container>
      );
    } else {
      return <div> LOADING </div>;
    }
  }
}

export default TripDetails;



// WEBPACK FOOTER //
// ./src/components/pages/Trips/TripDetails.jsx